import isBrowser from './isBrowser'

export const getQueryParam = (key: string) => {
  if (!isBrowser()) return
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(`^(?:.*[&\\?]${encodeURIComponent(key).replace(/[.+*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`, 'i'),
      '$1',
    ),
  )
}
